import { SvgIcon } from '@material-ui/core'

export function AttachmentIcon(props) {
  return (
    <SvgIcon {...props} fill="none">
      <path
        d="M17.5 5.25581V16.5C17.5 19.5376 15.0376 22 12 22C8.96243 22 6.5 19.5376 6.5 16.5V5.66667C6.5 3.64162 8.14162 2 10.1667 2C12.1917 2 13.8333 3.64162 13.8333 5.66667V16.4457C13.8333 17.4583 13.0125 18.2791 12 18.2791C10.9875 18.2791 10.1667 17.4583 10.1667 16.4457V6.65116"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill={'none'}
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
